"use client";

import { useAuthState } from "@/hooks/use-auth-state";

import { useRewardsList } from "./use-rewards-list";

export function useClaimableRewardsCount(): number {
  const { accountAddress } = useAuthState();
  const { data } = useRewardsList(accountAddress);
  return data.counts.claimable;
}
